// extracted by mini-css-extract-plugin
module.exports = {"root":"CardDetailLink_root__aWVgY"};